import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { IRosreestrDataMeta } from '../../services/rosreestrData';

export const UPDATE_CADASTRAL_FIELDS_META = 'CADASTRAL_FIELDS :: UPDATE_META';

export type TUpdateCadastralFieldsMetaAction = IReduxAction<typeof UPDATE_CADASTRAL_FIELDS_META, IRosreestrDataMeta[]>;

export const updateCadastralFieldsMeta = actionGenerator<typeof UPDATE_CADASTRAL_FIELDS_META, IRosreestrDataMeta[]>(
  UPDATE_CADASTRAL_FIELDS_META,
);
